import ModalsManagerContext from "contexts/ModalsManager";
import SignalsContext from "contexts/SignalsContext";
import { useContext, useEffect } from "react";

const ModalsManager = () => {
  const { modals, setModals } = useContext(ModalsManagerContext);
  const { callback, children, parent, setChildren, setParent } =
    useContext(SignalsContext);

  const setParentModal = () => {
    if (parent?.length) return;

    const keys = Object.keys(modals);
    const values = Object.values(modals);
    let modalIndex = -1;

    values.forEach((value, index) => {
      if (value === true) {
        if (value === true && modalIndex !== -1) {
          console.log("finded second modal function is leaving");
          return;
        }
        if (keys[index] !== "hide") {
          modalIndex = index;
        }
      }
    });

    if (keys[modalIndex] === "hide") return;

    setParent(keys[modalIndex]);
  };

  const checkAllModalsWasClose = () => {
    const values = Object.values(modals);
    // console.log(modals);
    let allClosed = true;

    values.forEach((value) => {
      if (value) {
        allClosed = false;
      }
    });

    if (!allClosed) return;
    console.log("cleaning after modals");
    setParent("");
    setChildren("");
  };

  const checkChildren = () => {
    if (!children.length) return;
    const keys = Object.keys(modals);
    const index = keys.findIndex((f) => f === children);
    const copyOfModals = { ...modals };
    copyOfModals[keys[index]] = true;
    setModals(copyOfModals);
  };

  useEffect(() => {
    setParentModal();
    checkAllModalsWasClose();
  }, [modals]);

  useEffect(() => {
    checkChildren();
  }, [children]);

  useEffect(() => {
    // console.log("###DEBUG###");
    // console.log("Parent state: ", parent);
    // console.log("children state: ", children);
    // console.log("callback state: ", callback);
    console.log("modals state: ", modals);
  }, [modals, parent, children, callback]);

  return <></>;
};

export default ModalsManager;
